export default "__VITE_ASSET__23bf3b62__"